import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return ['input'];
  }


  initialize(){

  }


  submit(e){
    e.preventDefault();
    this.inputTargets.forEach(function(v, i) {
      if (v.nodeName == 'SELECT'){
      v.options.selectedIndex = 0;
      }
      else {
        v.value = null; 

      }

    })
  }

  }



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/reset_date_selects_controller.js